import { Injectable } from '@angular/core';
import { Product } from '@core/models/piramide/Product';
import {
  CoolerCpu,
  CoolerFan,
  Cpu,
  Disco,
  Fuente,
  Gabinete,
  Memoria,
  Mother,
  PlacaVideo,
} from '../model';
import { DataArmado } from './DataArmado';
import { FA_CoolerCpu } from './FA_CoolerCpu';
import { FA_CoolerFan } from './FA_CoolerFan';
import { FA_Cpu } from './FA_Cpu';
import { FA_Disco } from './FA_Disco';
import { FA_Fuente } from './FA_Fuente';
import { FA_Gabinete } from './FA_Gabinete';
import { FA_Memoria } from './FA_Memoria';
import { FA_Mother } from './FA_Mother';
import { FA_Video } from './FA_Video';

@Injectable({
  providedIn: 'root',
})
export class FuncionesArmadoAgrupador {
  constructor(
    private fa_coolerCpu: FA_CoolerCpu,
    private fa_mother: FA_Mother,
    private fa_cpu: FA_Cpu,
    private fa_gab: FA_Gabinete,
    private fa_coolerFan: FA_CoolerFan,
    private fa_disco: FA_Disco,
    private fa_fuente: FA_Fuente,
    private fa_memoria: FA_Memoria,
    private fa_video: FA_Video,
  ) {}

  ejecutar = (armado: DataArmado, producto: Product) => {
    if (producto instanceof CoolerCpu) {
      return this.fa_coolerCpu.ejecutar(armado, producto);
    } else if (producto instanceof Cpu) {
      return this.fa_cpu.ejecutar(armado, producto);
    } else if (producto instanceof Mother) {
      return this.fa_mother.ejecutar(armado, producto);
    } else if (producto instanceof Gabinete) {
      return this.fa_gab.ejecutar(armado, producto);
    } else if (producto instanceof CoolerFan) {
      return this.fa_coolerFan.ejecutar(armado, producto);
    } else if (producto instanceof Disco) {
      return this.fa_disco.ejecutar(armado, producto);
    } else if (producto instanceof Fuente) {
      return this.fa_fuente.ejecutar(armado, producto);
    } else if (producto instanceof Memoria) {
      return this.fa_memoria.ejecutar(armado, producto);
    } else if (producto instanceof PlacaVideo) {
      return this.fa_video.ejecutar(armado, producto);
    } else {
      return [];
    }
  };
}
